module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/partenariat1-d51df399d260c6d2525ca44c184dde22.jpg";